<template>
  <div class="container-lg">
    <Nav />
    <main id="main">
      <Sidenav />
      <div class="col offset-3 p-0 deneme">
        <router-view />
      </div>
    </main>
  </div>
</template>
<script>
import Nav from "@/components/Shared/Nav";
import Sidenav from "@/components/Shared/Sidenav";
export default {
  components: { Nav, Sidenav },
};
</script>

<style></style>
